import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchProductDataThunk, saveProductThunk } from './productThunk';
const initialState: any = {
    product: {
        productData: [],
        editedData: [],
        loading: true,
        error: false,
    },
    saveProduct: {
        success: false,
        loading: false,
        error: null,
    }
};

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        //edit text
        updateProductField: (state, action: PayloadAction<{
            fieldPath: string;
            newValue: any;
        }>) => {
            const { fieldPath, newValue } = action.payload;
            const keys = fieldPath.split('.');
            let target = state.product.editedData[0];
            keys.slice(0, -1).forEach(key => {
                target = target[key];
            });
            target[keys[keys.length - 1]] = newValue;
        },
        revertProductField: (state, action: PayloadAction<{
            fieldPath: string;
        }>) => {
            const { fieldPath } = action.payload;
            const keys = fieldPath.split('.');
            let editedTarget = state.product.editedData[0];
            let originalTarget = state.product.productData[0];
            keys.slice(0, -1).forEach(key => {
                editedTarget = editedTarget[key];
                originalTarget = originalTarget[key];
            });
            editedTarget[keys[keys.length - 1]] = originalTarget[keys[keys.length - 1]];
        },
        commitProductField: (state, action: PayloadAction<{
            fieldPath: string;
        }>) => {
            const { fieldPath } = action.payload;
            const keys = fieldPath.split('.');

            let editedTarget = state.product.editedData[0];
            let originalTarget = state.product.productData[0];

            // Traverse both objects to the same field path
            keys.slice(0, -1).forEach(key => {
                editedTarget = editedTarget[key];
                originalTarget = originalTarget[key];
            });

            originalTarget[keys[keys.length - 1]] = editedTarget[keys[keys.length - 1]];
        },
        // lifestyle
        triggerProductReplacement: (state, action) => {
            state.product.productData[0].replacedPhotoRealisticViewStatus = 'Processing';
            state.product.editedData[0].replacedPhotoRealisticViewStatus = 'Processing';
            state.product.productData[0].photoRealisticParentTemplateId = action.payload.activeParticularTemplateId;
            state.product.editedData[0].photoRealisticParentTemplateId = action.payload.activeParticularTemplateId;
        },
        updatePollingProductData: (state, action) => {
            const merged = {
                ...state.product.productData[0],
                ...action.payload
            };

            const deepClone = JSON.parse(JSON.stringify(merged));

            state.product.productData[0] = deepClone;
            state.product.editedData[0] = deepClone;
        },
        updateSiloImages: (
            state,
            action: PayloadAction<{ siloImages: any[], isSiloImagesCategorized?: boolean }>
        ) => {
            if (action.payload.isSiloImagesCategorized !== undefined) {
                state.product.productData[0].isSiloImagesCategorized = action.payload.isSiloImagesCategorized;
                state.product.editedData[0].isSiloImagesCategorized = action.payload.isSiloImagesCategorized;
            }
            const newImages = action.payload.siloImages;

            const productItem = state.product.productData[0];
            const editedItem = state.product.editedData[0];

            // PRODUCT DATA
            if (!productItem.siloImagesWithWhiteBg || !productItem.siloImagesWithWhiteBg.length) {
                productItem.siloImagesWithWhiteBg = [...newImages];
            } else {
                productItem.siloImagesWithWhiteBg.push(...newImages);
            }

            // EDITED DATA
            if (!editedItem.siloImagesWithWhiteBg || !editedItem.siloImagesWithWhiteBg.length) {
                editedItem.siloImagesWithWhiteBg = [...newImages];
            } else {
                editedItem.siloImagesWithWhiteBg.push(...newImages);
            }
        },
        updateLifeStyleImagesFromSilos: (state, action) => {
            const newImages = action.payload.lifeStyleImagesFromSilos;

            const productItem = state.product.productData[0];
            const editedItem = state.product.editedData[0];

            // PRODUCT DATA
            if (!productItem?.lifeStyleImagesFromSilos || !productItem?.lifeStyleImagesFromSilos?.length) {
                productItem.lifeStyleImagesFromSilos = [...newImages];
            } else {
                productItem.lifeStyleImagesFromSilos.push(...newImages);
            }

            // EDITED DATA
            if (!editedItem.lifeStyleImagesFromSilos || !editedItem.lifeStyleImagesFromSilos.length) {
                editedItem.lifeStyleImagesFromSilos = [...newImages];
            } else {
                editedItem.lifeStyleImagesFromSilos.push(...newImages);
            }
        },
        updateThreeDModelUrl: (state, action) => {
            state.product.productData[0].threedImage = action.payload;
            state.product.editedData[0].threedImage = action.payload;
            state.product.productData[0].isThreeDUrlValid = true;
            state.product.editedData[0].isThreeDUrlValid = true;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchProductDataThunk.pending, (state) => {
                state.product.loading = true;
                state.product.error = null;
            })
            .addCase(fetchProductDataThunk.fulfilled, (state, action: PayloadAction<any>) => {
                state.product.productData = action.payload;
                // Create a deep copy for editable data
                state.product.editedData = JSON.parse(JSON.stringify(action.payload));
                state.product.loading = false;
            })
            .addCase(fetchProductDataThunk.rejected, (state, action) => {
                state.product.loading = false;
                state.product.error = action.error.message || 'Something went wrong';
            });

        builder.addCase(saveProductThunk.pending, (state) => {
            state.saveProduct.loading = true;
            state.product.error = null;
        })
            .addCase(saveProductThunk.fulfilled, (state, action: PayloadAction<any>) => {
                state.saveProduct.loading = false;
                state.saveProduct.success = true;
            })
            .addCase(saveProductThunk.rejected, (state, action) => {
                state.saveProduct.loading = false;
                state.saveProduct.error = action.error.message || 'Something went wrong';
                state.saveProduct.success = false;
            });
    },
});
export const { actions: productActions } = productSlice
export default productSlice.reducer;
